module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('hero'), _vm._v(" "), _c('about'), _vm._v(" "), _c('do'), _vm._v(" "), _c('skills'), _vm._v(" "), _c('fork'), _vm._v(" "), _c('contact'), _vm._v(" "), _c('copyright')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f25833a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 546
// module chunks = 1